import {Component, OnInit, input, Input, OnChanges, SimpleChange, SimpleChanges} from '@angular/core';
import {CheckboxModule} from "primeng/checkbox";
import {TooltipModule} from "primeng/tooltip";
import {FormsModule} from "@angular/forms";
import {InputTextModule} from "primeng/inputtext";
import {PaginatorModule} from "primeng/paginator";
import {FieldsetModule} from "primeng/fieldset";
import {SplitButtonModule} from "primeng/splitbutton";
import {
    ProjectDescriptorComponent
} from "../../project-descriptor-entries/project-descriptor/project-descriptor.component";
import {MenuModule} from "primeng/menu";
import {OrderListModule} from "primeng/orderlist";
import {
    ProjectDescriptorCategory,
    ProjectDescriptorCategoryVariant,
    ProjectSchemaDisplay
} from "../../../../api/project_schemas";
import {ProjectProfileGroup} from "../../../../api/db/entities/ProjectProfileGroup";
import {ProjectDescriptorUse} from "../../../../api/enums";


@Component({
    selector: 'project-descriptor-category',
    imports: [
    CheckboxModule,
    TooltipModule,
    FormsModule,
    InputTextModule,
    PaginatorModule,
    FieldsetModule,
    SplitButtonModule,
    ProjectDescriptorComponent,
    MenuModule,
    OrderListModule
],
    templateUrl: './project-descriptor-category.component.html',
    styleUrl: './project-descriptor-category.component.scss'
})

export class ProjectDescriptorCategoryComponent implements OnInit {
    readonly variant = input.required<ProjectDescriptorCategoryVariant>();
    //@Input({required: true}) readonly variant: ProjectDescriptorCategory;
    readonly category = input.required<ProjectDescriptorCategory>();
    readonly schemaDisplay = input.required<ProjectSchemaDisplay>();
    readonly profileGroup = input.required<ProjectProfileGroup>();
    readonly use = input.required<ProjectDescriptorUse>();

    constructor() {
    }

    ngOnInit(): void {
        console.log('In category component: ', this.category());
        console.log("This should be the variant: ", this.variant());
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['profileGroup']) {
            //console.log("CHANGES CODES IN PDC CATEGORY RUNNING");
            //console.log(this.profileGroup());
        }
    }
}
